export class ClientAccountInviteConstants {
  public static CLIENT_ACCOUNT_INVITE = 'client-account-invite'
}
